import { Outlet } from "react-router-dom";
import { Sidebar, MobileNav } from "@/components/Sidebar";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] text-zinc-900">
      <Sidebar />
      <MobileNav />
      <main className="pb-24 md:pl-64">
        <div className="mx-auto max-w-7xl px-5 pt-8 sm:px-10 sm:pt-12">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
